<template>
  <md-card class="md-card-product" @click="test">
    <md-card-header class="md-card-header-image">
      <slot name="imageHeader"></slot>
    </md-card-header>

    <md-card-content>
      <slot name="title"></slot>
      <slot name="description"></slot>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  name: "product-card",
  props: {},
  data() {
    return {
      fixedHeader: false
    };
  },
  computed: {},
  methods: {
    test() {
      console.log("test");
    }
  }
};
</script>

<style lang="scss"></style>
